import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DownloadOutlined } from '@ant-design/icons';
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "blue",
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ExpectedClosureTracker = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [store, setStore] = useState([]);
  const [commonExpCenter, setExpCenter] = useState([]);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showDetailedModal, setShowDetailedModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const csvButtonRef = useRef(null);
  const [expectedClosureTableCsvData, setExpectedClosureTableCsvData] = useState([]);
  const expectedClosureTableCsvButtonRef = useRef(null);
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [popMonthData, setPopMonthData] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectLost, setSeletLost] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];

const [pivot, setPivot] = useState('');

  useEffect(() => {
    expCenters();
    checkPivot('expectedClosureTracker')
    setSelectedRole('ALL')
  }, []);

  // Trigger download when data is ready
  useEffect(() => {
    if (triggerDownload && expectedClosureTableCsvData.length > 0) {
      const timer = setTimeout(() => {
        if (expectedClosureTableCsvButtonRef.current?.link) {
          try {
            expectedClosureTableCsvButtonRef.current.link.click();
          } catch (error) {
            console.error("Error triggering CSV download:", error);
            props?.setSnackInfo("Error downloading CSV", "error");
          }
          setTriggerDownload(false);
        } else {
          // Retry if link is not ready
          setTimeout(() => {
            if (expectedClosureTableCsvButtonRef.current?.link) {
              expectedClosureTableCsvButtonRef.current.link.click();
              setTriggerDownload(false);
            }
          }, 200);
        }
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [triggerDownload, expectedClosureTableCsvData]);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectCode", label: "Project No." },
    { key: "leadNumber", label: "Lead No." },
    { key: "clientName", label: "Client Name" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "currentStage", label: "Current Stage" },
    { key: "department", label: "Department" },
    { key: "expectedClosureDate", label: "Expected Closure Date" },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
  ];

  const csvDownloadHandler = async (data) => {
    setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < popMonthData.length; i++) {
        let obj = {
            serialNo: i + 1,
            projectCode: popMonthData[i]?.erpProjectNo || "N/A",
            leadNumber: popMonthData[i]?.lead_no || "N/A",
            clientName: popMonthData[i]?.customerId?.name || "N/A", // Corrected the optional chaining
            expCtrName: popMonthData[i]?.experienceCenterId?.name || "N/A",
            currentStage: popMonthData[i]?.currentStage || "NA",
            department: popMonthData[i]?.departmentId?.name || "NA",
            expectedClosureDate: moment(popMonthData[i]?.expectedSalesclosureDate).format('DD-MM-YYYY') || "NA",
            leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
            salesExecutive: popMonthData[i]?.salesUser?.name || "NA",
            asm: popMonthData[i]?.salesAssistantManager?.name || "NA",
          };
          
        csvArray.push(obj);
        // obj = {
        //   serialNo: "",
        //   projectCode: "",
        //   leadNumber: "",
        //   clientName: "",
        //   totalValue: "",
        //   expCtrName: "",
        //   currentStage: "",
        //   department: "",
        //   expectedClosureDate: "",
        //   leadCreatedDate: "",
        //   salesExecutive: "",
        //   asm: ""

        // };
        // csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const expCenterData = {};
  store.forEach((el) => {
      if (!expCenterData[el.experienceCenterName]) {
          expCenterData[el.experienceCenterName] = [];
      }
      expCenterData[el.experienceCenterName].push(el);
  });

  const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
  let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const expectedClosureTrackerData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
    let expCenterData = addExpCenter?.map((el) => el._id);
    let users = "";
    if ((usersData?.users && usersData?.users.length !== 0) ||(selectedUsers && selectedUsers.length !== 0)) {
      users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
    }
    let obj = {
      startDate: storeDateFilter.startDate,
      endDate: storeDateFilter.endDate,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      tokenPercentage: selectedValue !== "" ? selectedValue : "",
      users: users ? users : "",
      userExpCenter: userDetails.experienceCenterId,
      lost: selectLost !== "" ? selectLost : "",
      pivotValue: "expectedClosureTracker",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
      selectedRole: 'ALL'
    };
    props.setLoading(true);
    try {
      let response = await HttpService.getExpectedClosureDataBasedOnExpCenter(obj);
      setStore(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const checkPivot = async (value) => {
    setPivot(value)
     if (value === 'expectedClosureTracker') {
        expectedClosureTrackerData();
        setSelectedExperienceCenter([]);
        setSelectedUsers([]);
        setSelectedRole("ALL")
        setSearchInput("")
        setSelectedSearchType("")
    } 
}

  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleSearch = async (value) => {
    expectedClosureTrackerData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    expectedClosureTrackerData(selectedExperienceCenter, selectedUsers, "", "");
  };

  const getDataBasedOnClick = async (e,innerEl, status) => {
    let expCenterData = selectedExperienceCenter?.map((el) => el._id)
    let users = ''
    if (selectedUsers && selectedUsers.length !== 0) {
        users = selectedUsers?.map((el) => el._id)
    }
    let obj = {
        startDate: storeDateFilter.startDate,
        endDate: storeDateFilter.endDate,
        status: status,
        selectedExperienceCenter:  innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
        userExpCenter: userDetails.experienceCenterId,
        pivotValue: "expectedClosureTracker",
        tokenPercentage: selectedValue !== "" ? selectedValue : "",
        users: users ? users : "",
        searchType: selectedSearchType ? selectedSearchType : "",
        search: searchInput !== "" ? searchInput.toUpperCase() : ""
    }
    props.setLoading(true);
    obj.role = selectedRole
    try {
        let response = await HttpService.getDataBasedClickExpectedClosure(obj);
        setPopMonthData(response.data)
        setShowDetailedModal(true)
    } catch (error) {
        props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false);
}
  
  return (
    <div className="App">
      {/* first table */}
      <div>
        <div>
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown} // Listening for the "Enter" key press
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
        {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
              <h3 style={{ margin: 0 }}>Expected Closure Tracker</h3>
              <CSVLink
                data={expectedClosureTableCsvData}
                filename={`Expected_Closure_Tracker_${moment().format('YYYY-MM-DD')}.csv`}
                ref={expectedClosureTableCsvButtonRef}
                style={{ textDecoration: 'none', display: 'none' }}
              />
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  padding: "0.4rem 2rem",
                  border: "none"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // Generate CSV data synchronously
                  const csvData = (() => {
                    try {
                      if (!store || store.length === 0) {
                        return [];
                      }

                      // Compute expCenterData locally
                      const localExpCenterData = {};
                      store.forEach((el) => {
                        if (!localExpCenterData[el.experienceCenterName]) {
                          localExpCenterData[el.experienceCenterName] = [];
                        }
                        localExpCenterData[el.experienceCenterName].push(el);
                      });

                      const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

                      if (localUniqueexperienceCenterNames.length === 0) {
                        return [];
                      }

                      const csvRows = [];

                      // Row 1: Count of Cx Projected
                      const row1 = {
                        "Current Week (monday till sun)": "Current Week (monday till sun)",
                        "Particulars": "Count of Cx Projected"
                      };

                      // Add individual cell values matching table structure exactly
                      // Table iterates: uniqueexperienceCenterNames -> expCenterData[experienceCenterName] -> innerEl
                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            // Match table exactly - only add if expCenterCode exists
                            if (innerEl.expCenterCode) {
                              row1[innerEl.expCenterCode] = innerEl.count || 0;
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row1GrandTotal = Object.keys(row1).reduce((sum, key) => {
                        return (key !== "Current Week (monday till sun)" && key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row1[key]) || 0) : sum;
                      }, 0);
                      row1["Grand Total"] = row1GrandTotal;
                      csvRows.push(row1);

                      // Row 2: Total value of Projection Excl GST
                      const row2 = {
                        "Current Week (monday till sun)": "Current Week (monday till sun)",
                        "Particulars": "Total value of Projection Excl GST"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              row2[innerEl.expCenterCode] = (Math.floor((innerEl.totalValueOfProjection / 100000) * 100) / 100).toFixed(2);
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row2GrandTotal = Object.keys(row2).reduce((sum, key) => {
                        return (key !== "Current Week (monday till sun)" && key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row2[key]) || 0) : sum;
                      }, 0);
                      row2["Grand Total"] = (Math.floor(row2GrandTotal * 100) / 100).toFixed(2);
                      csvRows.push(row2);

                      // Row 3: Meeting done in above projection
                      const row3 = {
                        "Current Week (monday till sun)": "Current Week (monday till sun)",
                        "Particulars": "Meeting done in above projection"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              row3[innerEl.expCenterCode] = innerEl.meetingDoneAboveProjection || 0;
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row3GrandTotal = Object.keys(row3).reduce((sum, key) => {
                        return (key !== "Current Week (monday till sun)" && key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row3[key]) || 0) : sum;
                      }, 0);
                      row3["Grand Total"] = row3GrandTotal;
                      csvRows.push(row3);

                      // Row 4: Total value of meeting projection(ex gst)
                      const row4 = {
                        "Current Week (monday till sun)": "Current Week (monday till sun)",
                        "Particulars": "Total value of meeting projection(ex gst)"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              row4[innerEl.expCenterCode] = (Math.floor((innerEl.totalValueOfProjMeetingsDone / 100000) * 100) / 100).toFixed(2);
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row4GrandTotal = Object.keys(row4).reduce((sum, key) => {
                        return (key !== "Current Week (monday till sun)" && key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row4[key]) || 0) : sum;
                      }, 0);
                      row4["Grand Total"] = (Math.floor(row4GrandTotal * 100) / 100).toFixed(2);
                      csvRows.push(row4);

                      return csvRows;
                    } catch (error) {
                      console.error("Error generating expected closure table CSV:", error);
                      return [];
                    }
                  })();

                  // Set the data and trigger download
                  if (csvData.length > 0) {
                    setExpectedClosureTableCsvData(csvData);
                    // Use a longer timeout to ensure state is updated
                    setTimeout(() => {
                      setTriggerDownload(true);
                    }, 100);
                  } else {
                    props?.setSnackInfo("No data available to export", "warning");
                  }
                }}
              >
                Download CSV
              </Button>
            </div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "10px" }}
            >
              <Table style={{ minWidth: "500px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        text:'white'
                      }}
                    >
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}

                      style={{ position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        color:'white'
                     }}
                    >
                    </StyledTableCell>

                      {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                        <StyledTableCell className={classes.bordercolors} key={index}
                          style={{
                            fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                            fontWeight: index === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                            textAlign: 'center',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                          }}>
                          <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                            <span style={{ cursor: "pointer" }}>
                              {experienceCenterName.expCenterCode}
                            </span>
                          </Tooltip>
                        </StyledTableCell>
                      ))}

                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ textAlign: "center" , color:'white', fontWeight:'bold' }}>
                        Grand Total
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                   <StyledTableCell rowSpan={4} style={{ color: 'white', fontWeight:'bold', textAlign: "center" }}> Current Week (monday till sun)</StyledTableCell>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black'}}> Count of Cx Projected </StyledTableCell>
                      {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'countOfCxProjection')}
                            >
                               { innerEl.count } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black'}}>Total value of Projection Excl GST</StyledTableCell>
                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'totalValueOfCxProjection')}
                            >
                               {(Math.floor((innerEl.totalValueOfProjection  / 100000) * 100) / 100) .toFixed(2)}
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black'}}>Meeting done in above projection</StyledTableCell>
                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'meetingDoneProjectionCount')}
                            >
                               { innerEl.meetingDoneAboveProjection } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black'}}>Total value of meeting projection(ex gst)</StyledTableCell>
                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                background: "white",
                                textDecoration:'underline',
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'meetingDoneProjectionValue')}
                            >
                               {(Math.floor((innerEl.totalValueOfProjMeetingsDone  / 100000) * 100) / 100) .toFixed(2)}
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
          </div>
        {/* } */}
        </div>
      </div>
     

      <Modal
        title="Expected Closure Tracker Data"
        centered
        visible={showDetailedModal}
        onCancel={() => setShowDetailedModal(false)}
        width={1000}
        maskClosable={true}
        footer={null}
      >
        <div className={classes.csv}>
          <CSVLink
            headers={headers}
            filename={`expectedClosureTrackerData.csv`}
            data={csvData}
            ref={csvButtonRef}
          />
          <Button
            onClick={() => csvDownloadHandler(popMonthData)}
            style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
            variant="contained"
            color="secondary"
          >
            Download CSV
          </Button>
        </div>
        {popMonthData && (
          <TableContainer component={Paper} className={classes.table}>
            <Table
              style={{ width: 450 }}
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sl. No.</StyledTableCell>
                  <StyledTableCell>Project No.</StyledTableCell>
                  <StyledTableCell>Lead No.</StyledTableCell>
                  <StyledTableCell>Client Name</StyledTableCell>
                  <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                  <StyledTableCell>Current Stage</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Expected Closure Date</StyledTableCell>
                  <StyledTableCell>Lead Created Date</StyledTableCell>
                  <StyledTableCell>Sales Executive</StyledTableCell>
                  <StyledTableCell>ASM</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {popMonthData &&
                  popMonthData.map((data, i) => {
                    return (
                      <>
                        <StyledTableRow key={i}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.erpProjectNo ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.erpProjectNo}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.lead_no ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.customerId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.experienceCenterId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.currentStage}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.departmentId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.expectedSalesclosureDate).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.createdAt).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesUser ? data?.salesUser?.name : 'NA'}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesAssistantManager ? data?.salesAssistantManager?.name : 'NA'}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(ExpectedClosureTracker);


